import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a5564f2a")

_pushScopeId("data-v-a5564f2a")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "right-container flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = { class: "flex-grow flex flex-col items-center justify-between bg-primary-100 overflow-y-scroll overflow-x-scroll px-12 pt-12" }
const _hoisted_4 = { class: "panel-container rounded-md bg-white pb-2 mb-16 lg:mb-8" }
const _hoisted_5 = { class: "w-full table-header-color px-4 py-3" }
const _hoisted_6 = { class: "flex items-center sticky left-0 justify-end" }
const _hoisted_7 = { class: "mr-2 hidden lg:block" }
const _hoisted_8 = { class: "px-1 hidden lg:flex text-gray-400" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "text-gray-600 pr-4 hidden lg:inline" }, "表示終了日が過ぎた提出物を表示", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 締切日の期間を指定 ")
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 mr-1",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" })
], -1)
const _hoisted_12 = { class: "px-4 py-2 flex items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "mr-1 text-xs text-gray-700" }, "開始", -1)
const _hoisted_14 = { class: "px-4 py-2 flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "mr-1 text-xs text-gray-700" }, "終了", -1)
const _hoisted_16 = { class: "flex justify-center" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" データ更新 ")
const _hoisted_18 = /*#__PURE__*/_createVNode("p", null, "提出物マスター設定", -1)
const _hoisted_19 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "提出物情報取得中...", -1)
const _hoisted_21 = { class: "panel-container rounded-md bg-white px-6 py-4 mb-16 lg:mb-8" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "flex mb-4 flex-col md:flex-row" }, [
  /*#__PURE__*/_createVNode("span", { class: "mb-2 md:mb-0 md:mr-4" }, "提出画像のストレージ使用率"),
  /*#__PURE__*/_createVNode("div", { class: "text-red-500 text-sm" }, [
    /*#__PURE__*/_createVNode("p", null, " ※スクール全体で「生徒数×1GB」を最大容量としています。容量が最大となった場合、古いデータから順に削除されます。 ")
  ])
], -1)
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = { class: "w-6/12 bg-gray-200 mr-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_table_condition_item = _resolveComponent("m-table-condition-item")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_MLoadingIcon = _resolveComponent("MLoadingIcon")
  const _component_m_table = _resolveComponent("m-table")
  const _component_SubmissionMasterAddModal = _resolveComponent("SubmissionMasterAddModal")
  const _component_SubmissionMasterEditModal = _resolveComponent("SubmissionMasterEditModal")
  const _component_SubmissionMasterCopyModal = _resolveComponent("SubmissionMasterCopyModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_MNavBar),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_MHeaderPanel, {
          title: "提出BOX",
          breadcrumbs: []
        }),
        _createVNode("main", _hoisted_3, [
          _createVNode("section", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.query = $event)),
                    type: "search",
                    name: "searchSubmission",
                    placeholder: "提出物名で検索...",
                    class: "w-36 sm:w-52 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                  }, null, 512), [
                    [_vModelText, _ctx.query]
                  ])
                ]),
                _createVNode("label", _hoisted_8, [
                  _createVNode("input", {
                    type: "checkbox",
                    name: "select",
                    class: "cursor-pointer",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeShowDisplayEndDateFlag()))
                  }, null, 32)
                ]),
                _hoisted_9,
                _createVNode(_component_m_table_condition_item, {
                  class: "hidden lg:block",
                  active: !!_ctx.closedAtTerm
                }, {
                  body: _withId(() => [
                    _createVNode("ul", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.closedAtTerms, (term) => {
                        return (_openBlock(), _createBlock("li", {
                          key: term.id,
                          class: ["list-none flex items-center w-full px-4 py-2 text-gray-700 cursor-pointer transition-all duration-300 hover:bg-gray-100 hover:text-primary-600", {
                        'text-gray-700': term.value != _ctx.closedAtTerm,
                        'text-primary-500': term.value == _ctx.closedAtTerm
                      }],
                          onClick: ($event: any) => (_ctx.changeClosedAtTerm(term.value))
                        }, _toDisplayString(term.value), 11, ["onClick"]))
                      }), 128))
                    ]),
                    _createVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_m_text_field, {
                        name: "termStart",
                        type: "date",
                        placeholder: "2021/04/01",
                        value: _ctx.termStart,
                        entered: "",
                        class: "flex-1",
                        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeTermStart($event)))
                      }, null, 8, ["value"])
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_m_text_field, {
                        name: "termEnd",
                        type: "date",
                        placeholder: "2021/04/01",
                        value: _ctx.termEnd,
                        entered: "",
                        class: "flex-1",
                        onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeTermEnd($event)))
                      }, null, 8, ["value"])
                    ]),
                    _createVNode("div", _hoisted_16, [
                      _createVNode(_component_m_button, {
                        color: "secondary-500",
                        outline: "",
                        size: "sm",
                        onClick: _ctx.loadSubmissionMaster
                      }, {
                        default: _withId(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  default: _withId(() => [
                    (_ctx.closedAtTerm)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" 締切日：" + _toDisplayString(_ctx.closedAtTerm), 1)
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _hoisted_10
                        ], 64)),
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["active"]),
                _createVNode(_component_m_button, {
                  color: "primary-500",
                  "hover-color": "primary-600",
                  onClick: _ctx.showAddModal
                }, {
                  default: _withId(() => [
                    _createVNode(_component_m_icon, {
                      type: "plus",
                      width: "4",
                      class: "mr-2"
                    }),
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            (_ctx.load)
              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                  _createVNode(_component_MLoadingIcon),
                  _hoisted_20
                ]))
              : (_openBlock(), _createBlock(_component_m_table, {
                  key: 1,
                  datas: _ctx.filteredTableData,
                  definitions: _ctx.definitions,
                  "count-per-page": 40,
                  "use-actions": "",
                  onSelect: _ctx.changeSelectedId,
                  onCopy: _ctx.copySelectedId
                }, null, 8, ["datas", "definitions", "onSelect", "onCopy"]))
          ]),
          _createVNode("section", _hoisted_21, [
            _hoisted_22,
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode("div", {
                  class: "bg-red-400 font-medium leading-none h-full",
                  style: { width: `${_ctx.allocatedPercent}%` }
                }, null, 4)
              ]),
              _createVNode("div", null, _toDisplayString(_ctx.allocatedStorageSizeGB) + "GB / " + _toDisplayString(_ctx.maxStorageSizeGB) + "GB（" + _toDisplayString(_ctx.allocatedPercent) + "%使用中） ", 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.isDisplayedAddSubmissionMasterModal)
      ? (_openBlock(), _createBlock(_component_SubmissionMasterAddModal, {
          key: 0,
          "submission-masters": _ctx.tableData,
          onClose: _ctx.closeAddModal
        }, null, 8, ["submission-masters", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayedEditSubmissionMasterModal)
      ? (_openBlock(), _createBlock(_component_SubmissionMasterEditModal, {
          key: 1,
          "submission-master": _ctx.submissionMaster,
          onClose: _ctx.closeEditModal
        }, null, 8, ["submission-master", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isDisplayedCopySubmissionMasterModal)
      ? (_openBlock(), _createBlock(_component_SubmissionMasterCopyModal, {
          key: 2,
          "submission-master": _ctx.submissionMaster,
          "submission-masters": _ctx.tableData,
          onClose: _ctx.closeCopyModal
        }, null, 8, ["submission-master", "submission-masters", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
})